var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',[_c('b-col',{attrs:{"cols":"12","md":"5"}},[_c('odeme-tanimla')],1),_c('b-col',{attrs:{"cols":"12","md":"7"}},[_c('banka-bilgileri')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }